import type { BackendPaginationMeta } from 'src/components/ServerPaginatedTable/types';

export type { BackendPaginationMeta };

export type StaffContactType = 'doctor' | 'assistant' | 'treatment_coordinator';

export type StaffContactSortField = 'name' | 'type' | 'createdAt';

export interface StaffContactRecord {
  _id: string;
  name: string;
  type: StaffContactType;
  userId: string;
  createdAt: string;
  updatedAt: string;
}

export interface StaffContactListQuery {
  offset: number;
  limit: number;
  sortBy?: StaffContactSortField;
  sortOrder?: 'ASC' | 'DESC';
}

export interface StaffContactGroupedListData {
  doctors: StaffContactRecord[];
  assistants: StaffContactRecord[];
  treatmentCoordinators: StaffContactRecord[];
}

export interface StaffContactListResult {
  contacts: StaffContactRecord[];
  pagination: BackendPaginationMeta;
}

export type StaffContactApiData =
  | StaffContactRecord
  | StaffContactGroupedListData
  | { id: string };

export interface StaffContactApiResponse {
  statusCode: number;
  msg: string;
  data: StaffContactApiData;
  pagination?: BackendPaginationMeta;
}

export const isStaffContactGroupedListData = (
  data: StaffContactApiData,
): data is StaffContactGroupedListData =>
  typeof data === 'object' &&
  data !== null &&
  'doctors' in data &&
  'assistants' in data &&
  'treatmentCoordinators' in data;

export const mergeStaffContactGroups = (
  data: StaffContactGroupedListData,
): StaffContactRecord[] => [
  ...(data.doctors ?? []),
  ...(data.assistants ?? []),
  ...(data.treatmentCoordinators ?? []),
];

export interface StaffContactPayload {
  accessToken: string;
}

export interface FetchStaffContactsPayload extends StaffContactPayload {
  query?: StaffContactListQuery;
}

export interface CreateStaffContactPayload extends StaffContactPayload {
  name: string;
  type: StaffContactType;
}

export interface UpdateStaffContactPayload extends StaffContactPayload {
  id: string;
  name?: string;
  type?: StaffContactType;
}

export interface DeleteStaffContactPayload extends StaffContactPayload {
  id: string;
}
